import React, {useRef} from 'react';
import emailjs from '@emailjs/browser';              
import "./contact.css"

const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
      e.preventDefault();
  
      emailjs
        .sendForm('service_ubi2gom', 'template_1utjoiz', form.current, {
          publicKey: 'mFawJ1NsMmAbqp_k8',
        })

        e.target.reset();
    };

  return (
    <section className="contact section" id="contact">
            <h2 className="section__title">Send Me a Message</h2>
            <span className="section__subtitle">Contact me</span>

            <div className="contact__container container grid">
                <div className="contact__content">
                    <h3 className="contact__title">Get in Touch</h3>

                    <div className="contact__info">
                        <div className="contact__card">
                            <i className="bx bx-mail-send contact__card-icon" aria-hidden="true"></i>

                            <h3 className="contact__card-title">Email</h3>
                            <span className="contact__card-data">verstech73@gmail.com</span>

                            <a 
                                href="mailto:verstech73@gmail.com" 
                                className="contact__button"
                                aria-label="Send email to verstech73@gmail.com"
                            >
                                Write me{" "}
                                <i className="bx bx-right-arrow-alt contact__button-icon" aria-hidden="true"></i>
                            </a>
                        </div>

                        <div className="contact__card">
                            <i className="bx bxl-whatsapp contact__card-icon" aria-hidden="true"></i>

                            <h3 className="contact__card-title">Whatsapp</h3>
                            <span className="contact__card-data">+234 9131 5783 84</span>

                            <a 
                                href="https://wa.me/message/EWQ3IEYBAST2E1"
                                className="contact__button"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Send WhatsApp message to +234 9131 5783 84"
                            >
                                Write me{" "}
                                <i className="bx bx-right-arrow-alt contact__button-icon" aria-hidden="true"></i>
                            </a>
                        </div>

                        <div className="contact__card">
                            <i className="bx bxl-messenger contact__card-icon" aria-hidden="true"></i>

                            <h3 className="contact__card-title">Messenger</h3>
                            <span className="contact__card-data">Imran Olona Mustopha</span>

                            <a 
                                href="https://m.me/techVersifier" 
                                className="contact__button"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Send Facebook Messenger message to Imran Olona Mustopha"
                            >
                                Write me{" "}
                                <i className="bx bx-right-arrow-alt contact__button-icon" aria-hidden="true"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="contact__content">
                    <h3 className="contact__title">Connect for Project Inquiries</h3>

                    <form ref={form} onSubmit={sendEmail} className="contact__form">
                        <div className="contact__form-div">
                            <input 
                                type="text" 
                                name='name' 
                                id="contact-name"
                                className="contact__form-input"
                                placeholder='MIONova'
                                required
                                aria-describedby="name-label"
                            />
                            <label htmlFor="contact-name" className="contact__form-tag" id="name-label">
                                Name
                            </label>
                        </div>

                        <div className="contact__form-div">
                            <input 
                                type="email" 
                                name='email' 
                                id="contact-email"
                                className="contact__form-input"
                                placeholder='e-address@gmail.com'
                                required
                                aria-describedby="email-label"
                            />
                            <label htmlFor="contact-email" className="contact__form-tag" id="email-label">
                                Mail
                            </label>
                        </div>

                        <div className="contact__form-div contact__form-area">
                            <textarea 
                                name="project" 
                                id="contact-project"
                                cols="30" 
                                rows="10"
                                className='contact__form-input' 
                                placeholder='What would you like to discuss?'
                                required
                                aria-describedby="project-label"
                            ></textarea>
                            <label htmlFor="contact-project" className="contact__form-tag" id="project-label">
                                Project
                            </label>
                        </div>

                        <button 
                            type="submit"
                            className="contact__button button--flex"
                            aria-label="Send message"
                        >
                            Send Messages
                            <svg 
                                className="button__icon" 
                                width="24" 
                                height="24" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                xmlns="http://www.w3.org/2000/svg"
                                role="img"
                                aria-hidden="true"
                            >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <path 
                                        d="M12.0004 18.5816V12.5M12.7976 18.754L15.8103 19.7625C17.4511 20.3118 18.2714 20.5864 18.7773 20.3893C19.2166 20.2182 19.5499 19.8505 19.6771 19.3965C19.8236 18.8737 19.4699 18.0843 18.7624 16.5053L14.2198 6.36709C13.5279 4.82299 13.182 4.05094 12.7001 3.81172C12.2814 3.60388 11.7898 3.60309 11.3705 3.80958C10.8878 4.04726 10.5394 4.8182 9.84259 6.36006L5.25633 16.5082C4.54325 18.086 4.18671 18.875 4.33169 19.3983C4.4576 19.8528 4.78992 20.2216 5.22888 20.394C5.73435 20.5926 6.55603 20.3198 8.19939 19.7744L11.2797 18.752C11.5614 18.6585 11.7023 18.6117 11.8464 18.5933C11.9742 18.5769 12.1036 18.5771 12.2314 18.5938C12.3754 18.6126 12.5162 18.6597 12.7976 18.754Z" 
                                        stroke="currentColor" 
                                        strokeWidth="2" 
                                        strokeLinecap="round" 
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                        </button>
                    </form>
                </div>
            </div>
    </section>
  )
}

export default Contact

